import { RefProperty } from '../../../ref-property.model';

export class SystemLogPresenterModel {
  /**
   * The details of the log.
   */
  details: any;

  /**
   * The time the action was performed.
   */
  doneAt: string;
  doneBy: RefProperty;
  id?: string;
}
